import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { StringArrayFilterCard } from "~/components/Filters/StringArrayFilterCard";
import { PublicVideoAspectRatiosSelect } from "~/components/Filters/VideoAspectRatioFilter/components/PublicVideoAspectRatiosSelect";
export const PublicVideoAspectRatioFilterCard = /*#__PURE__*/ memo((param)=>{
    let { boardId, ...props } = param;
    const renderVideoAspectRatiosSelect = useCallback((props)=>/*#__PURE__*/ _jsx(PublicVideoAspectRatiosSelect, {
            boardId: boardId,
            ...props
        }), [
        boardId
    ]);
    return /*#__PURE__*/ _jsx(StringArrayFilterCard, {
        filter: "videoAspectRatios",
        filterCardType: "videoAspectRatio",
        StringSelect: renderVideoAspectRatiosSelect,
        ...props
    });
});
PublicVideoAspectRatioFilterCard.displayName = "PublicVideoAspectRatioFilterCard";
